import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./Reveal";

const faqs = [
  {
    q: "What exactly is a Brightspot?",
    a: "A Brightspot is our name for a partner neighborhood store on the Zeroomile network. It's a trusted local hub — a beacon of service — that fulfils your orders in minutes using Zeroomile technology.",
  },
  {
    q: "How fast is delivery?",
    a: "Because your order is picked from a Brightspot right around the corner, most deliveries land at your doorstep within the hour — often in minutes.",
  },
  {
    q: "Which cities is Zeroomile available in?",
    a: "We're live across 5+ cities and expanding fast. New Brightspots are joining the network every week — check the app for availability near you.",
  },
  {
    q: "Can my store become a Brightspot?",
    a: "Absolutely. Zeroomile empowers local sellers by turning their store into a Brightspot — bringing them digital orders, logistics and technology. Reach out through the links below to join the network.",
  },
  {
    q: "What can I order on Zeroomile?",
    a: "Over 3,000 products across groceries & staples, personal care, baby care, beverages, pooja needs and more — curated from local and global brands.",
  },
];

export const FaqSection = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="mx-auto max-w-[1400px] px-6 py-24 md:px-12 md:py-32"
    >
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
        <div className="md:col-span-4">
          <Reveal>
            <p className="mb-6 text-xs uppercase tracking-[0.3em] text-brand-volt">Support</p>
            <h2 className="font-display text-6xl uppercase leading-[0.9] tracking-tight md:text-7xl">
              Frequently
              <br />
              asked
            </h2>
          </Reveal>
        </div>

        <div className="md:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-brand-line"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="py-6 text-left text-xl font-normal text-brand-bone transition-colors duration-300 hover:text-brand-volt hover:no-underline md:text-2xl [&>svg]:text-brand-volt"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 text-base leading-relaxed text-brand-muted">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
